import {
  createContext,
  ReactNode
} from "react";

import { useSubscriptionSynchronizerOld } from "v2/hooks/billing/useSubscriptionSynchronizer";


export type UserContextType = {};

let UserContext = createContext<UserContextType>({});
/**
 * @deprecated  should reimplement the useEffect calls in a global component or hook, or simply just rename this not to be a provider anymore
 * @param param0
 * @param param0.children
 * @constructor
 */
export default function UserProvider({ children }: { children: ReactNode }) {
  useSubscriptionSynchronizerOld();

  let value: UserContextType = {};
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
